export enum AnswerStatus {
  PENDING = 'PENDING',
  PENDING_OTP = 'PENDING_OTP',
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
  FREE = 'FREE',
  HUMP = 'HUMP',
}
